import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import './personal-info.css';
var FontAwesome = require('react-fontawesome');

class PersonalInfo extends Component {

    constructor() {
        super();
        this.state = {
            personalInfo: []
        };
    }

    componentWillMount() {
        this.setState({
            personalInfo: [
                {
                    name: "phone",
                    icon: "phone",
                    content: "052-5709620",
                    link: "tel:0525709620"
                },
                {
                    name: "email",
                    icon: "at",
                    content: "ranmariuma@gmail.com",
                    link: "mailto:ranmariuma@gmail.com"
                },
                {
                    name: "birth-year",
                    icon: "birthday-cake",
                    content: "1993"
                }
            ],
            socialNetworks: [
                {
                    name: "linkedin",
                    link: "https://www.linkedin.com/in/ran-mariuma",
                    icon: "linkedin"
                },
                {
                    name: "Github",
                    link: "https://github.com/maryum375",
                    icon: "github-square"
                },
                {
                    name: "facebook",
                    link: "https://www.facebook.com/ran.mariuma",
                    icon: "facebook-square"
                },
                {
                    name: "stackoverflow",
                    link: "https://stackoverflow.com/users/1018192/maryum375",
                    icon: "stack-overflow"
                }
            ]
        })
    }

    render() {
        let piItems = this.renderPiItems();

        return (
            <Grid fluid={true} className="pi-wrapper">
                <Row>
                    <Col xs={12} sm={4}>
                        <img src="./assets/img/passport-photo.jpg" className="profile-photo" alt="" />
                    </Col>
                    <Col xs={12} sm={8}>
                        <div className="pi-text-content">
                            <h4 className="pi-title">
                                Ran Mariuma
                                </h4>
                            {piItems}
                        </div>
                    </Col>
                </Row>
            </Grid>
        );
    }


    renderPiItems() {
        let personalInfo;
        let socialNetworks;
        if (this.state.personalInfo) {
            personalInfo = this.renderPersonalInfoItems();
            let socialNetworks = this.renderSocialNetworks();
            personalInfo.push(socialNetworks)
        }
        return personalInfo;
    }

    renderPersonalInfoItems() {
        return this.state.personalInfo.map(infoItem => {
            return <div key={infoItem.name} className="pi-item">
                <FontAwesome name={infoItem.icon} />

                <span className="pi-item-content">
                    {infoItem.link ?
                        (<a href={infoItem.link}>
                            {infoItem.content}
                        </a>)
                        :
                        infoItem.content
                    }

                </span>
            </div>
        })
    }

    renderSocialNetworks() {
        return <div className="pi-item" key="social">
        <div className="pi-item social-icons" key="social">
                {this.state.socialNetworks.map(socialItem => {
                    return <a key={socialItem.name} href={socialItem.link} className="social-icon" target="_blank">
                        <FontAwesome name={socialItem.icon} />
                    </a>
                })}
            </div>
        </div>
    }
}

export default PersonalInfo;



// WEBPACK FOOTER //
// ./src/components/personal-info/personal-info.js